import { createSelector } from "@reduxjs/toolkit";

import type { EmailTemplate } from "./types";

const selectSlice = (state: any) => state.emailTemplates;

export const selectEmailTemplates = createSelector(
  selectSlice,
  (slice): EmailTemplate[] => slice?.items || [],
);

export const selectEmailTemplatesLoading = createSelector(
  selectSlice,
  (slice): boolean => Boolean(slice?.loading),
);

export const selectEmailTemplatesSaving = createSelector(
  selectSlice,
  (slice): boolean => Boolean(slice?.saving),
);

export const selectEmailTemplatesError = createSelector(
  selectSlice,
  (slice): string | null => slice?.error || null,
);

export const selectEmailTemplateCategories = createSelector(
  selectSlice,
  (slice): import("./types").EmailTemplateCategory[] =>
    slice?.categories || [],
);

export const selectEmailTemplateCategoriesLoading = createSelector(
  selectSlice,
  (slice): boolean => Boolean(slice?.categoriesLoading),
);
